import { WorkingHoursContractScreenData } from "@/modules/working_hours/domain/WorkingHoursContractScreenData";

export class VueWorkingHoursContractScreenData implements WorkingHoursContractScreenData {
  loading: boolean;
  showTrial: boolean;

  constructor() {
    this.loading = false;
    this.showTrial = false;
  }

  setLoading(loading: boolean) {
    this.loading = loading;
  }

  setShowTrial(show_trial: boolean) {
    this.showTrial = show_trial;
  }
}